import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function TheProblem() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-teal-900 text-white py-16 md:py-20" data-id="element-166">
      <div className="max-w-4xl mx-auto px-6" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.7
      }} data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-169">
            El Problema Real
          </h2>

          <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-170">
            Para la mujer profesional de más de 45 años, la niebla mental no es
            solo un síntoma molesto; es una amenaza a su autoridad y a su
            confianza.
          </p>

          <div className="space-y-4 text-lg md:text-xl leading-relaxed" data-id="element-171">
            <p data-id="element-172">Es leer el mismo correo tres veces sin procesarlo.</p>
            <p data-id="element-173">
              Es entrar a una habitación y quedarte parada sin saber qué
              buscabas.
            </p>
            <p data-id="element-174">
              Es sentir que tu cerebro está envuelto en melaza desde las 3 de la
              tarde hasta que te acuestas, solo para despertarte al día
              siguiente sintiendo que no has descansado nada.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}